export default __webpack_public_path__ + "static/media/glowtail.5cac6877.png";